import { Component, OnInit, Input } from '@angular/core';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { CarrierService } from 'app/services/carrier.service';
import { AuthWebService } from 'app/services/authweb.service';
import { CarrierworkflowService } from 'app/services/carrierworkflow.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from 'app/popup/alert.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DocumentsServiceService } from 'app/services/documents-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CarrierAccountService } from 'app/services/carrier-account.service';

@Component({
  selector: 'submission',
  templateUrl: './submission.component.html',
  styleUrls: ['./submission.component.css']
})
export class SubmissionComponent implements OnInit {
  @Input('ctrlData') ctrlData: any;
  public isLoading = false;
  caConfirmObj: any = {};
  carrierAccountObj: any = {};
  userInfo: any;
  decl_date = new Date();
  declaration = "";
  form: any;
  status_id: number;
  email_body = "";
  message = "Submitting your request, please wait...";
  message1 = "Unable to submit";
  feedback : any ={};
  isLoadingImg: boolean;
  doc: any;
  isPDF: number;
  debtoraccount: any = {}; 
  showDocs: boolean = false;
  accountBalance:number;
  subject = 'Acknowledgement of carrier account submission';
  turnOverBrand:any={
    1:"Less than R1 Mil",
    2:"Between R1 Mil and R5 Mil",
    3:"Above R5 Mil"
  }
  constructor(private carrierAccountService: CarrierAccountService, private documentService: DocumentsServiceService,private router: Router,private carrierService: CarrierService, public utility: UtilityServiceService,
    private authWebService: AuthWebService, private activateRoute:ActivatedRoute,
    private wService: CarrierworkflowService, private msg: ToastrService,private sanitizer: DomSanitizer) { }

  ngOnInit() {
    //alert('at 1');
    ////console.clear();
    console.log("User Data", this.accountBalance);
    if(this.router.url.indexOf('carrier')>0){
      let  id:any=this.activateRoute.params['_value'].id;
      this.utility.carrierId=id;
    }
    //console.log("Values:")
    //console.log(this.ctrlData);
    //this.utility.carrierObject=this.ctrlData;
    this.getCarrierInfo(this.utility.carrierId);
    this.caConfirmObj.Demographic=null;
    this.retrieveSubmitStatus();
    this.getConfirmDetails();    
    this.setConfigdata();
    this.createForm();
    this.setDeclareReadOnly();
    this.getDebtorAccount(this.activateRoute.params['_value'].id);
        
    console.log('this.caConfirmObj.carrier_id : ' +JSON.stringify(this.caConfirmObj.carrier_code));
    console.log('this.caConfirmObj : ' +JSON.stringify(this.caConfirmObj));
  }

  getUpdateBalance() {    
    //alert('at 2');
    if(this.caConfirmObj.carrier_status === 'Approved')
    {     
      this.carrierService.getUpdateBalance(this.carrierAccountObj.carrier_account_id).subscribe(res => {

      });
    }
  }

  getDebtorAccount(id:number)
  {      
    //alert('at 3');
    this.carrierAccountService.getCarrierAccountByID(id).subscribe(result => {
      this.carrierAccountObj = result;
      this.getUpdateBalance();
   }, error => {
     console.log('Error occured: ' + error);
   })   
  }

  getConfirmDetails = () => {
    //alert('at 4');
    this.isLoading = true;
    this.message = "Retrieving carrier account information, please wait...";
    let carrierId:any=this.utility.carrierId;
    if(this.utility.ctrlPages[this.utility.acc.First].carrierId==undefined){
      carrierId=this.utility.carrierId;
    }else{
      if(this.utility.carrierId==undefined){
        carrierId=this.utility.ctrlPages[this.utility.acc.First].carrierId;
      }
    }
    this.carrierService.getAccountConfirmationDetailsById(carrierId).subscribe(result => {
      this.caConfirmObj = result;
      if(parseInt(this.caConfirmObj.account_balance)!=0){
        this.caConfirmObj.account_balance=-(parseInt(this.caConfirmObj.account_balance));
        this.accountBalance = this.caConfirmObj.account_balance;   
        
      }

      console.log('this.caConfirmObj : '+JSON.stringify(this.caConfirmObj));
      this.isLoading = false;
      this.showDocs=true;
    }, error => {
      this.isLoading = false;
      //console.log(error);
    });
  }
  back(){    
    //alert('at 5');
    this.utility.activeTab = 2;    
  }

  setConfigdata = () => {
    //alert('at 6');
    this.userInfo = this.authWebService.userInfo();
    let declaration: any;
    if (this.authWebService.userData) {
      declaration = this.authWebService.userData.Configurations.find(
        config => config.Code == "HTMLDec1");
    }
    this.declaration = declaration.Value;
  }

  setDeclareReadOnly() {
    //alert('at 7');
    if (!this.utility.isBtnVisible) {
      this.form.get('uAgreed').disable();
      this.form.get('uAgreed').value = true;
    }
  }

  createForm=()=> {
    //alert('at 8');
    this.form = new UntypedFormGroup({
      carrier_id: new UntypedFormControl(this.utility.ctrlPages[this.utility.acc.First].carrierId)
      , uAgreed: new UntypedFormControl(null, Validators.compose([this.validateSubmit]))
      , status_id: new UntypedFormControl(this.status_id)
      , submittedOn: new UntypedFormControl(new Date())
      , email_body: new UntypedFormControl(this.email_body)
      , username: new UntypedFormControl(this.userInfo.username)
      , emailAddress: new UntypedFormControl(this.userInfo.emailAddress)
      , subject: new UntypedFormControl(this.subject)
    });
    this.form.patchValue(this.utility.defaults);
  }

  onSubmit = (obj: any) => {

    if(!this.form.valid){
      return this.msg.warning('Please click the declaration box','Declaration')
    }
    
    //if(this.accountBalance==null || this.accountBalance==0) {
    //  return this.showError("Unable to submit the application, You have insufficient funds");
    //}

    //alert('at 9');

    this.isLoading = true;
    this.message = 'Saving...'
    this.carrierService.processSubmission(obj).subscribe(result => {
      this.isLoading = false;
      if (result == true) {

        //alert('at 10');

        this.showSuccess(`Carrier Account with registration number  ${ this.caConfirmObj.registration_number } submitted successfully.`);
        //this.dialogService.addDialog(AlertComponent, { title: `Carrier Account Submission`, message: `Carrier Account with registration number  ${this.caConfirmObj.registration_number} submitted successfully.`, bold: `${this.caConfirmObj.registration_number}` });
        this.startWorkflow();
        this.utility.activeTab = 1;
        //alert('omg2');
        this.utility.landingPage();
      } else {
        //alert('at 11');
        this.showError(`Submission for  ${this.caConfirmObj.registration_number} failed. Please contact the system administrator if the problem persists.`);
      }
    }, error => {
      this.isLoading = false;
      this.showError(`Submission for  ${this.caConfirmObj.registration_number} failed. Please contact the system administrator if the problem persists.`);
      //this.dialogService.addDialog(AlertComponent, { title: `Carrier Account Submission`, message: `Submission for  ${this.caConfirmObj.registration_number} failed.Please contact the system administrator if the problem persists.`, bold: `${obj.registered_name}` });
    });
  }

  retrieveSubmitStatus = () => {
    //alert('at 12');
    if (this.authWebService.userData) {
      this.status_id =+ this.authWebService.userData.Configurations.find(config => config.Code == "AccountStatus2").Value;
      const emailConfig:any = this.authWebService.userData.Configurations.find(config => config.Code == "SubmitEmail1");
      this.email_body = emailConfig.Value;
       (emailConfig.Description)
        this.subject = emailConfig.Description;
    }
  }

  validateSubmit(control: UntypedFormControl) {
    //alert('at 13');
    let checked = control.value;
    if (!checked) {
      return {
        checked: {
          saIdnumer: checked
        }
      }
    }
    return null;
  }

  startWorkflow()
  {
    //alert('at 14');
    this.wService.startCreateCarrierWorkflow(this.utility.ctrlPages[this.utility.acc.First].carrierId).subscribe(result => {
      this.feedback = result;
    }, error => {
      //console.log(error);
    });
  }

  showSuccess(msg) {
    this.msg.success(msg, 'Carrier Account Submission');
  }

  showError = (msg) => {
    this.msg.error(msg, 'Carrier Account Submission');
  }
  viewDoc(fileName){
    //console.log(fileName)
  if(fileName!=undefined){
    this.isLoadingImg = true;
    this.doc = null;
    this.isPDF = 0;
   let id = fileName.substring(fileName.indexOf('#')+1);
   //console.log(id)
    if(fileName.includes('.pdf')){
      this.documentService.downloadpdf(id).subscribe(x => {
        let objectURL = URL.createObjectURL(x);
        this.doc = objectURL;
        this.isPDF = 1;
        this.isLoadingImg = false;
      })
      return
    }
    this.documentService.download(id).subscribe(x => {
      let objectURL = URL.createObjectURL(x);
      this.isPDF = 2;
      this.doc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      this.isLoadingImg = false;
    })
  }
}

getCarrierInfo(carrierId){
    this.carrierService.carrierInfo(carrierId).subscribe(res=>{
      this.ctrlData.data=res;
      this.ctrlData.carrierId=carrierId;
      this.utility.carrierObject=this.ctrlData;   
      console.log('this.ctrlData.data : '+JSON.stringify(this.ctrlData.data));
    });
}

checkBalanceBeforeSubmit()
{
  if(this.accountBalance == null)
  return true;
if(this.accountBalance < 1)
  return true;
else
  return false;
}

isAccountBalanceNullOrZero()
{
  if(this.accountBalance == null)
    return true;
  if(this.accountBalance < 1)
    return true;
  else
    return false;
}
}
